export const appNameMapping  = {
  "ItemCreator": "Artikel erstellen",
  "LabelPrinter": "Preisschild drucken",
  "DataChecker": "Datenbank-Checks",
  "OnlineOffline_Artikel": "Online Offline Artikel",
  "OnlineOffline_Liste": "Online Offline Liste",
  "ListingCreator": "Listing erstellen",
  "ItemPricing": "Artikel-Preise",
  "OrderProcessing": "Auftrags-bearbeitung",
  "AdminPanel": "Admin Panel",
  "StatisticsAnalyzer": "Statistiken analysieren",
};

export const markets = {
    "102.00": "Kaufland",
    "102.01": "Kaufland DE",
    "14.00": "AWIN",
    "4.01": "Amazon Germany",
    "150.00": "Check24",
    "15.00": "Facebook",
    "7.00": "Google Shopping",
    "125.00": "Hood",
    "0.00": "Manuelle Eingabe",
    "135.00": "Newsletter2GO",
    "1.00": "WebShop",
    "5.00": "Yatego",
    "2.00": "eBay",
    "2.05": "eBay Austria",
    "2.08": "eBay Germany",
    "19.00": "Möbel24.de",
    "17.00": "QR-Code",
    "148.00": "WEB-API",
    "160.10": "Otto market"
}